<div class="app-checkbox-wrapper" [ngClass]="computedStyleClass()">
    <p-checkbox #checkbox [ngModel]="checkboxValue() !== undefined ? value() : checked()"
        (ngModelChange)="checkboxValue() !== undefined ? value.set($event) : null" [value]="checkboxValue()"
        [binary]="checkboxValue() === undefined" [name]="checkboxConfig().name || ''"
        [inputId]="checkboxConfig().inputId || ''" [disabled]="isDisabled()" [readonly]="isReadonly()"
        [tabindex]="checkboxConfig().tabindex" [ariaLabel]="checkboxConfig().ariaLabel"
        [ariaLabelledBy]="checkboxConfig().ariaLabelledBy" [style]="checkboxConfig().style"
        [variant]="checkboxConfig().variant" (onChange)="handleChange($event)">

        <!-- Custom checkbox icon template -->
        <ng-template pTemplate="icon" let-checked *ngIf="checkboxIconTemplate()">
            <ng-container *ngTemplateOutlet="checkboxIconTemplate()!; context: { $implicit: checked }"></ng-container>
        </ng-template>
    </p-checkbox>

    <!-- Label -->
    <label *ngIf="checkboxConfig().label || labelTemplate()" [for]="checkboxConfig().inputId"
        [ngClass]="checkboxConfig().labelStyleClass || 'checkbox-label'" class="cursor-pointer select-none">
        <ng-container *ngIf="labelTemplate(); else defaultLabel">
            <ng-container *ngTemplateOutlet="labelTemplate()!"></ng-container>
        </ng-container>
        <ng-template #defaultLabel>
            {{ checkboxConfig().label }}
        </ng-template>
    </label>
</div>